import AppConfigsService from '../../services/AppConfigsService';
import appConfigsUseCase from './appConfigsUseCase';

const appConfigsFactory = appConfigsUseCase({
  AppConfigsService: AppConfigsService(),
});

export default appConfigsFactory;
